export enum APIRequestResources {
    ApplicationService = 'application',
    AuthService = 'auth',
    GroupService = 'group',
    ResourceService = 'resource',
    RoleService = 'role',
    TenantService = 'tenant',
    UserService = 'user',
  }
